
<div class="col-lg-12 nopadding col-md-12">
  <div class="col-lg-12 nopadding ">
    <br>
    <div class="row nopadding">
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" appendTo="body"></p-confirmDialog>
      <div class="col-md-12 col-sm-12">
        <div class="col-md-4 col-sm-4">
          <div class="row">
            <div class="col-md-5 col-sm-5"><label for="reportDate"> Report Date: * </label></div>
            <div class="col-md-7 col-sm-7">
                  <app-datepicker-calendar [dateRange]="reportDateValue" [isDateRange]="true"  (dateChange)="getDateEmitter($event)"></app-datepicker-calendar>
                </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="row">
            <div class="col-md-4 col-sm-4"><label for="group"> Group:</label></div>
            <div class="col-md-8 col-sm-8">
              <p-select id="grpDropdown" [showClear]="true" name="fileTypeDropdown" (onChange)="validateFileType(FileTypeValue)"
                autofocus [options]="groupList" [(ngModel)]="groupValue" appendTo="body" placeholder="Select Group"
                [style]="{
                    'text-transform': 'capitalize',
                    overflow: 'visible',
                    width: '100%'
                  }">
                <ng-template let-filterCols pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <div [id]="filterCols.label">{{ filterCols.label }}</div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="row">
            <div class="col-md-4 col-sm-4"><label for="Submitter"> Submitter: </label></div>
            <div class="col-md-8 col-sm-8">
              <p-select  id="subDropdown" [showClear]="true" name="fileTypeDropdown" (onChange)="validateFileType(FileTypeValue)"
                autofocus [options]="submitterList" [(ngModel)]="submitterValue" appendTo="body"
                placeholder="Select Submitter" [style]="{
                  'text-transform': 'capitalize',
                  overflow: 'visible',
                  width: '100%'
                }">
                <ng-template let-filterCols pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <div [id]="filterCols.label">{{ filterCols.label }}</div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row nopadding">
      <div class="col-md-12 col-sm-12">
        <div class="col-md-4 col-sm-4">
          <div class="row">
          <div class="col-md-5 col-sm-5"> <label for="uploadType"> Upload Type: *</label></div>
            <div class="col-md-7 col-sm-7">
              <p-select id="uploadDrpdon" name="fileTypeDropdown" [showClear]="true" (onChange)="applyDate(FileTypeValue)"
                autofocus [options]="FileType" [(ngModel)]="FileTypeValue" appendTo="body"
                placeholder="Select file type" [style]="{ 'text-transform': 'capitalize', overflow: 'visible', width: '100%' }">
                <ng-template let-filterCols pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <div [id]="filterCols.label">{{ filterCols.label }}</div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4" >
          <div class="row">
            <!-- code is commented as per need , do not remove this -->

            <!-- <span *ngIf="FileTypeValue == 'Client Data'" [disabled]="isDiableFileType">
              <label class="col-md-6"> Client Data File Type : </label>
              <p-multiSelect id="multiselctInp" name="CATClientDataFileTypeDropdown"
                (onChange)="validateFileUpload($event, ClientDataFileTypeValue)" [disabled]="isDiableFileType"
                class="col-md-6" autofocus required="true" [options]="ClientDataFileType"
                [(ngModel)]="ClientDataFileTypeValue" appendTo="body" placeholder="Select File type" 
                [style]="{ 'text-transform': 'capitalize',overflow: 'visible',width: '100%'}" 
                pTooltip="Drag & Drop Files here" tooltipPosition="right">
              </p-multiSelect>
              <mat-error *ngIf="isDiableFileType == false && ClientDataFileTypeValue.length == 0">
                &nbsp;&nbsp; Please select file type</mat-error>

            </span> -->
            @if(FileTypeValue !== 'CAT' && FileTypeValue !== '' && FileTypeValue !== 'Submit CAT File' && FileTypeValue !== 'FINRA Named Error File') {
              <span style="color:#e74f4f;font-style: italic; font-size:12px">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> File name should starts with {{userService.getActiveMPID()}}_
              </span>
            } @else if(FileTypeValue === 'FINRA Named Error File') {
              <span style="color:#e74f4f;font-style: italic; font-size:12px">
                <i class="fa fa-info-circle" aria-hidden="true"></i> File name should be {{this.userService.CRDID}}_{{userService.getActiveMPID()}}_YYYYMMDD_OrderEvents.linkage.error_000001.csv.bz2, {{this.userService.CRDID}}_{{userService.getActiveMPID()}}_20250520_OrderEvents.linkage_outstanding.error_000001.csv.bz2 (Same type of JSON files are also accepted)
              </span>
            }
            @else if(FileTypeValue === 'Submit CAT File') {
              <span style="color:#e74f4f;font-style: italic; font-size:12px">
                <i class="fa fa-info-circle" aria-hidden="true"></i> File name should be <br> 93006_{{userService.getActiveMPID()}}_20250520_{{groupName}}_OrderEvents_100000.csv, 93006_{{userService.getActiveMPID()}}_20250520_{{groupName}}_OrderEvents_100000.csv.bz2(Same type of JSON files are also accepted)
              </span>
            }
            @if(FileTypeValue == 'CAT'){
            <span>
              <div class="col-md-6">
                <label for="clientDataFileType">&nbsp; Client Data File Type : </label>
              </div>
              <p-select id="clientDataDrpdwn" name="CATClientDataFileTypeDropdown" (onChange)="
                      validateFileUpload($event, FileTypeValue);
                      validateFileType(FileTypeValue)
                    " class="col-md-6" autofocus required="true" [options]="CATDataType"
                      [(ngModel)]="CATDataFileTypeValue" appendTo="body" placeholder="CAT Data Files" [style]="{
                      'text-transform': 'capitalize',
                      overflow: 'visible',
                    }" pTooltip="Drag & Drop Files here" tooltipPosition="right" styleClass="clientDataFileClass">
              </p-select>
            </span>}
          </div>
        </div>
        <div class="col-md-5">
        </div>

      </div>
    </div>
    <br><br>

    <!--File Upload Code -->
    @if(!isDiableFileupload){
    <div class="col-lg-12">
      <div>
        Drag & Drop Files here <i class="fa fa-arrows" aria-hidden="true"></i>
      </div>
      <p-fileUpload id="dragdropbox" #fileUpload name="datafiles" [disabled]="isDiableFileupload" [url]="FileUploadUrl" [auto]="false" 
        [accept]="FileExtentionValue" [showUploadButton]="isUploadEnable" [headers]="httpHeaders"
        (onSelect)="validateFileTest($event, fileUpload)" (onBeforeUpload)="onBeforeSend($event)"
        (onUpload)="onUpload($event)" (onError)="onUploadFailed($event)" multiple="multiple" styleClass="fileUpload">
        <ng-template pTemplate="content">

        </ng-template>
        <ng-template let-files #content>
        <div ngfDrop></div>
        @if(files.length>0){
        <p-progressbar [value]="totalSizePercent" [showValue]="false" class="w-full" class="md:w-20rem h-1 w-full md:ml-auto">
         </p-progressbar>
        }
         @for(file of files; track file + '-'+ $index; let i = $index) {
          <div class="ui-fileupload-row">
            <div>{{ file.name }}</div>
            <div>{{ getSizeInMegaBytes(file) | number: "1.2-2" }} MB</div>
            <div>
                <p-button name="removeFileUpload"  id="removeuploadFile" label="Remove" type="button" icon="pi pi-times"
                (click)="removeFile(file, fileUpload, i)" />  
            </div>
          </div>
        }
        </ng-template>
      </p-fileUpload>
    </div>}

    <!-- Gride Code -->
    <div class="col-lg-12">
      <br />
      @if(isLoadingResults){
      <div class="example-loading-shade">
        @if(isLoadingResults){
        <mat-spinner></mat-spinner>}
      </div>}
      <p-table id="fileUploadTable"
      [globalFilterFields]="['Source']" 
      [columns]="GridColumns" 
      [value]="dataset"
      [paginator]="true"
      [resizableColumns]="true"
      alwaysShowPaginator="true"
      columnResizeMode="expand" 
      appendTo="body" 
      [totalRecords]="dataset.length" 
      paginatorPosition="both"
      sortMode="multiple" 
      [rows]="constantService.DEFAULT_ROWSIZE" 
      [pageLinks]="constantService.DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"  
      [(selection)]="selectedRow"
      styleClass="fileUploadTable"
      #dt>
        <ng-template pTemplate="caption">
          <div style="text-align: left">
            <button name="GUI" pButton id="GUIButton" [ngClass]="filterByGui ? 'button btn-xs active-symbol-dark-blue':'button btn-xs non-active-symbol mg-t-2'" 
            (onClick)="filterByGui = !filterByGui;filterByGui?dt.filterGlobal('GUI', 'contains'):dt.filterGlobal('', 'contains')"
              type="button">GUI</button>
            <button id="startProcessingButton" class="col-md-1" name="startProcessingButton" type="button" 
            (click)="triggerFileUpload();" pButton>
            Upload and Process
            @if(startProcessing){
            <img style="text-align:center" alt="startProcessing"
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }</button>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th id="tableHeaderCheckbox" style="width: 3em">
              <p-tableHeaderCheckbox style="text-align: center;margin: 6px;"></p-tableHeaderCheckbox>
            </th>
            @for (col of columns; track col;){
            <th id="columns" pResizableColumn [pSortableColumn]="col.field" [ngClass]="
              (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
              {{ col.header }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>}
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row">
            <td>
              <p-tableCheckbox style="text-align: center;margin: 6px;" [id]="'selectCheckboxfileUpload'+ rowIndex" [value]="row" [disabled]="!(row['Source'] === 'GUI' && row['processStatus'] === 'File Uploaded')"></p-tableCheckbox>
            </td>
            @for (col of columns; track col;){
            <td class="ui-resizable-column" [ngClass]="
              (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
              @if(col.field==='action'){
              <span>
                <p-button [style]="{'texr-align': 'center','margin':'6px'}"
                 [id]="'file-upload-delete'+ rowIndex" [disabled]="!(row['Source'] === 'GUI' && row['processStatus'] === 'File Uploaded')" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete"
                 [matTooltipShowDelay]="1000"
                matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash" (click)="(row['Source'] === 'GUI' && row['processStatus'] === 'File Uploaded') ?setClearData(row):''">
              </p-button>
              @if(row['Source'] === 'GEN' || row['Source'] === 'SUB' ||
              ((this.userService.isRoleSuperUser() || this.userService.isRoleFirmAdmin())
               && this.FileTypeValue == 'CAIS' && (row['processedFlag'] === 'G' || row['processedFlag'] === 'S' ))){
                <span
                  [style]="{'texr-align': 'center'}">
                <span style="text-align: center;margin: 8px 0px;display: inline-block;padding-top: 0;margin-top: 0px;">
                    <p-button [id]="'download'+ rowIndex" matTooltip="Download" [matTooltipShowDelay]="1000" icon="fa fa-download" (click)="downloadFile(row,rowIndex)" styleClass="downloadFile"></p-button>
                  </span>
                </span>}
              </span>}
              <div [pTooltip]="row[col.field]" [id]="col.field"></div>
              @if((col.datatype | lowercase) != 'int' &&
                (col.datatype | lowercase) != 'float'){
              <span>
                {{ row[col.field] }}
              </span>}
              @if((col.datatype | lowercase) == 'int' ||
                (col.datatype | lowercase) == 'float'){
              <span style="float:right;">
                {{ row[col.field] }}
              </span>}
            </td>}
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- added this ng-template to align page navigator box in the middle-->
        </ng-template>
        <ng-template pTemplate="paginatorright">
          Total Records: {{ dataset.length == 0 ? 0 : dataset.length }}
        </ng-template>
      </p-table>
      <br />
    </div>
  </div>

    <!-- DialogBox for File Operation -->
    <p-dialog [(visible)]="isSelectProcessDate" styleClass="quick-view-grid-row filterbox " icon="pi pi-exclamation-triangle"
    width="425" appendTo="body" showEffect="fade" [modal]="true" (onHide)="isDisableSubmit = true">
    <ng-template #header>
      File Operation : {{FileTypeValue}}
      </ng-template>
    <div class="col-lg-12">
      <span>
        <div class="ui-g" style="margin-top: 10px;">
          <div class="ui-g-6 topPadding">
            <h4 class="textsize" matSubheader>Reporter </h4>
          </div>
          <div class="ui-g-6 topPadding">
            <h4 class="textsize" matSubheader>{{userService.getActiveMPID()}}</h4>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div>
          <div class="ui-g" style="margin-bottom: 10px; margin-top: 10px;">
            <div class="ui-g-6 topPadding">
              <h4 class="textsize" matSubheader>Report Date * </h4>
            </div>
            <div class="ui-g-6 topPadding">
              <app-datepicker-calendar [date]="selectedReportDate" [isDateRange]="false" (dateChange)="getDateEmitter($event)"></app-datepicker-calendar>
            </div>
          </div>
          <mat-divider></mat-divider>
          @if(isLoadingGroupList && !['CAIS', 'Submit CAT File', 'FINRA Named Error File'].includes(FileTypeValue)){
          <span class="ui-g" style="text-align:center">Loading Group list
            @if(isLoadingGroupList){
            <img style="text-align:center" alt="LoadingGroupList"
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }<mat-divider></mat-divider>
          </span>}
          @if(!isLoadingGroupList && !['CAIS', 'Submit CAT File', 'FINRA Named Error File'].includes(FileTypeValue)){
          <div class="ui-g" style="margin-bottom: 10px;">
            <div class="ui-g-6 topPadding">
              <h4 class="textsize" matSubheader>Group Name * </h4>
            </div>
            <div class="ui-g-6 topPadding">
              <h4 class="textsize" matSubheader>
                <p-select id="dropDown" [options]="groupListDropDown" [(ngModel)]="selectedGroup" (ngModelChange)="isDisableSubmit = false" appendTo="body"
                  [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select a Group" filter="true"
                  required="true">
                </p-select>
              </h4>
            </div>
          </div>}
        </div>
      </span>
    </div>
    <ng-template #footer>
      <p-button id="submit" class="nopadding"
        icon="fa fa-check"  [disabled]="isDisableSubmit && !['CAIS', 'Submit CAT File', 'FINRA Named Error File'].includes(FileTypeValue)" 
        (click)="(!isDisableSubmit || ['CAIS', 'Submit CAT File', 'FINRA Named Error File'].indexOf(FileTypeValue) !== -1) ? setStartProcessing() : ''" label="Submit">
      </p-button>
      </ng-template>
  </p-dialog>